var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isShowPopup && 'cur',attrs:{"id":"mask-layer-wrap"},on:{"click":function($event){_vm.isShowPopup = false}}},[_c('img',{staticClass:"mask-img",attrs:{"src":_vm.Images.img_share_prompt}})])}
var staticRenderFns = []

export { render, staticRenderFns }